module.exports = __webpack_public_path__ + "static/What_we_do_2x-aca7734d6f0326512f503e70b3b88b80.png";